import React from 'react'
import cn from 'classnames'

import { ChevronDownIcon } from '@components/icons/ChevronDownIcon'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { CommentCardProps } from '../interface'
import VisibleSection from './VisibleSection'
import CommentBox from './CommentBox'

const CommentCard = ({
  className,
  comment,
  rootId,
  isSubComment = false,
  unHiddenComment,
  onReplyCommentSubmit,
  replyUser,
  user,
  isReplyCommentBox = false,
  replyCommentBoxRef,
  editCommentId,
  authorUserId,
  isReadmore,
  isLastComment,
  handleClickReadmore,
  ...props
}: CommentCardProps) => {
  const {
    isLightOrSepiaTheme,
    isDarkTheme,
    isNightOrDarkTheme,
    isLightTheme,
    isSepiaTheme,
  } = useTheme()

  return (
    <div className='relative h-full pt-[20px]'>
      {comment.visible ? (
        <VisibleSection
          className={className}
          comment={comment}
          isSubComment={isSubComment}
          unHiddenComment={unHiddenComment}
          onReplyCommentSubmit={onReplyCommentSubmit}
          replyUser={replyUser}
          rootId={rootId}
          editCommentId={editCommentId}
          isLike={comment.isLiked}
          user={user}
          authorUserId={authorUserId}
          isReadmore={isReadmore}
          isLastComment={isLastComment}
          handleClickReadmore={handleClickReadmore}
          {...props}
        />
      ) : (
        <div className='flex flex-row justify-between items-start w-full'>
          <div className={cn(className)} />
          <div
            className={cn({
              'absolute ml-[25px] mt-[25px] z-[1] border-l-[1px] border-gray-3 h-full mobile:mt-[15px]':
                isSubComment && !isLastComment,
              'opacity-10': isNightOrDarkTheme,
            })}
          />
          <div
            className={cn({
              'w-[50px] h-[50px] mobile:mt-[25px] border-t-[1px] border-gray-3 mt-[25px] mobile:ml-[60px]':
                isSubComment,
              'border-none': comment.replied,
            })}
          />
          <div className='flex flex-row justify-center items-center w-full'>
            <div className='relative flex flex-col justify-center bg-gray-1 dark:bg-dark-9 rounded-[20px]  w-full text-[14px] text-secondary dark:text-dark-10 font-light'>
              <div className='p-[20px] text-center'>
                <p>
                  ความคิดเห็นนี้ถูกซ่อน
                  {comment.updatedBy?.id === authorUserId
                    ? 'โดยเจ้าของเรื่อง'
                    : comment.updatedBy?.id === comment.user?.id
                    ? 'โดยเจ้าของความคิดเห็น'
                    : null}
                  {comment.updatedBy?.id === user?.id && (
                    <span
                      onClick={() => unHiddenComment(Number(comment.id))}
                      className='text-primary underline cursor-pointer pl-[4px]'
                    >
                      เลิกซ่อน
                    </span>
                  )}
                </p>
              </div>
              {!!comment.childrenComment?.length &&
                comment.visible &&
                !isReadmore &&
                !isSubComment && (
                  <button
                    type='button'
                    onClick={handleClickReadmore}
                    className={cn(
                      'flex justify-center items-center space-x-[4px] w-full h-[50px] dark:text-blue-1 dark:bg-gray-17/20 left-0 rounded-b-[20px] font-sarabun text-[14px] font-medium cursor-pointer',
                      {
                        'bg-gray-4 text-secondary-1': isLightTheme,
                        'bg-sepia-4 text-secondary-1': isSepiaTheme,
                        'bg-gray-16/10 text-blue-1/50': isDarkTheme,
                      }
                    )}
                  >
                    <div>
                      ดู {comment.childrenComment?.length} ความคิดเห็นย่อย
                    </div>
                    <div className='mt-[2px]'>
                      <ChevronDownIcon width='18' height='18' />
                    </div>
                  </button>
                )}
            </div>
          </div>
        </div>
      )}
      {isReplyCommentBox && replyUser?.rootId === rootId && (
        <CommentBox
          ref={replyCommentBoxRef}
          onSubmit={onReplyCommentSubmit}
          user={user}
          replyUser={replyUser}
          mode='create'
          className={cn({
            'ml-[70px] mobile:ml-[60px]': !isSubComment,
            'ml-[175px] mobile:ml-[110px]': isSubComment,
          })}
        />
      )}
    </div>
  )
}

export default CommentCard
